import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from "@angular/core";
import { FormControl } from "@angular/forms";
import {
  bl_fi_mst_item_line_RowClass
} from "blg-akaun-ts-lib";
import { EInvoiceUomModel } from "../../models/einvoice-uom.model";
import { ReplaySubject, combineLatest } from "rxjs";
// import "rxjs/add/operator/take";
import { debounceTime, distinctUntilChanged, filter } from "rxjs/operators";
import { SubSink } from "subsink2";
interface PricingScheme {
  uom_guid: string;
  label_guid: string;
  price_name: string;
  price_amount: number;
}

@Component({
  selector: "app-einvoice-uom",
  templateUrl: "./einvoice-uom.component.html",
  styleUrls: ["./einvoice-uom.component.css"],
  changeDetection: ChangeDetectionStrategy.Default,
})
export class EinvoiceUOMComponent implements OnInit, OnDestroy {
  @Input() uom: FormControl;
  // @Input() fiitem$: Observable<FinancialItemContainerModel>;
  @Output() uomChange = new EventEmitter<FormControl>();
  @Output() selectedEInvoiceUomModel = new EventEmitter<any>();
  @Output() unitPrice = new EventEmitter<number>();
  @Input() viewModelStore;
  @Input() ColumnViewActions;
  @Input() ColumnViewSelectors;

  private subs = new SubSink();
  uomListings = [];

  uomfilterControl = new FormControl();
  filteredUOM$: ReplaySubject<bl_fi_mst_item_line_RowClass[]> =
    new ReplaySubject<bl_fi_mst_item_line_RowClass[]>(1);
  uomList: bl_fi_mst_item_line_RowClass[];
  selectedUOM;
  selectedPrice;
  baseUOM;
  fiItem;

  constructor(private cd: ChangeDetectorRef) {}

  ngOnInit() {
    this.subs.sink = combineLatest([
      this.viewModelStore.select(this.ColumnViewSelectors.selectFIItem),
    ])
      .pipe(
        filter(([item]) => item !== null && item !== undefined) // Wait for item to be truthy
      )
      .subscribe({
        next: ([item]: any) => {
          console.log("item", item);
          this.fiItem = item;
          this.baseUOM = <bl_fi_mst_item_line_RowClass>{
            ...item.bl_fi_mst_item_hdr,
            uom: item.bl_fi_mst_item_hdr.einvoice_uom,
            uomDesc: item.bl_fi_mst_item_hdr.einvoice_uom_desc,
            quantity: 1,
          };

          const baseEInvoiceUomModel = new EInvoiceUomModel();
          baseEInvoiceUomModel.baseUOM = this.baseUOM?.uom?.toString();
          baseEInvoiceUomModel.fiItemHdrGuid = this.baseUOM?.guid?.toString();
          baseEInvoiceUomModel.fiItemLineGuid = "";
          baseEInvoiceUomModel.uom = this.baseUOM?.uom?.toString();
          baseEInvoiceUomModel.einvoiceUomDesc = this.baseUOM?.uomDesc;
          baseEInvoiceUomModel.uomBaseRatio = 1;
          baseEInvoiceUomModel.isBaseUom = true;

          let multiUomArr = [];
          let multiUom = [...item.bl_fi_mst_item_lines].filter((l) => l.uom);
          //console.log("multiUom",multiUom);

          multiUom.forEach((data) => {
            //console.log("EachMulti",data)
            const multiEInvoiceUomModel = new EInvoiceUomModel();
            multiEInvoiceUomModel.baseUOM = this.baseUOM.uom?.toString();
            multiEInvoiceUomModel.fiItemHdrGuid = data?.hdr_guid?.toString();
            multiEInvoiceUomModel.fiItemLineGuid = data?.guid.toString();
            multiEInvoiceUomModel.uom = data?.einvoice_uom?.toString();
            multiEInvoiceUomModel.einvoiceUomDesc = data?.einvoice_uom_desc;
            multiEInvoiceUomModel.uomBaseRatio = data?.quantity;
            multiEInvoiceUomModel.isBaseUom = false;
            multiUomArr.push(multiEInvoiceUomModel);
          });

          this.uomListings = [baseEInvoiceUomModel, ...multiUomArr];

          // console.log("Uom Listimg",this.uomListings);
          this.selectedUOM = this.uomListings[0].uom;

          if (this.uom.value) {
            this.onUOMSelected(this.uom.value);
          }

          this.filteredUOM$.next(this.uomListings);
        },
      });

    this.subs.sink = this.uomfilterControl.valueChanges
      .pipe(debounceTime(300), distinctUntilChanged())
      .subscribe({ next: (resolve) => this.filterUOM(resolve) });
  }

  filterUOM(search: string) {
    if (!search) {
      this.filteredUOM$.next(this.uomListings);
    } else {
      search = search.toLowerCase();
      const filter = this.uomListings.filter((l) =>
        l.uom.toLowerCase().includes(search)
      );
      this.filteredUOM$.next(filter);
    }
  }

  onUOMSelected(e) {
    //console.log("Even From Selected Uom",e);
    this.selectedUOM = e;

    const uom = this.uomListings.find((l) => l.uom === e);
    this.selectedEInvoiceUomModel.emit(uom);
    //console.log("UOM", uom);
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }
}
